import { gql } from '@apollo/client';

import client from '../../../../core/services/graphql';

export const GET_AVAILABILTIES_BY_PROJECT = gql`
  query Availabalities($projectId: ID!) {
    availabilities(projectId: $projectId) {
      id
      startAt
      endAt
    }
  }
`;

export const GET_TESTERS_BY_PROJECT_ID = gql`
  query ProjectParticipants(
    $projectId: ID!,
    $approved: Boolean,
    $isCompleted: Boolean,
    $tsIsApproved: Boolean,
    $limit: Int!,
    $offset: Int!
    $removed: Boolean
    $hideNoScheduled: Boolean,
    $bookingStatus: [TestSessionBookingStatusEnum!],
  ) {
    testersCount(
      projectId: $projectId,
      approved: $approved,
      isCompleted: $isCompleted,
      tsIsApproved: $tsIsApproved,
      removed: $removed,
    )
    segmentsCount(
      projectId: $projectId,
    )
    testers(
      projectId: $projectId,
      limit: $limit,
      offset: $offset,
      approved: $approved,
      isCompleted: $isCompleted,
      tsIsApproved: $tsIsApproved,
      removed: $removed,
      bookingStatus: $bookingStatus,
      hideNoScheduled:  $hideNoScheduled
    ) {
      id
      approved
      removed
      qualifiedAt
      testerPayment {
        id
        status
      }
      testSessions {
        id
        videoKey
        videoUrl
        status
        approved
        removed
        newVideo
        startAt
        endAt
        bookingStatus
        meetingUrl
        startUrl
        createdAt
        completedAt
        testSessionCardSortCategories {
          id
          cardSortCategory {
            id
            name
          }
          testSessionCardSortItems {
            id
            cardSortItem {
              id
              name
              description
              imageUrl
            }
          }
        }
      }
      segment {
        id,
        name
        surveys {
          id
          surveyType
          version
          questions {
            id
            label
            questionOrder
            questionOptions {
              id
              label
              disqualify
              qualify
              order
              optionType
            }
          }
        }
      }
      user {
        id
        guest
        email
        profile {
          id
          firstName
          lastName
          jobInfo
          gender
          birthdate
          country
          raceEthnicHeritage
          annualHouseholdIncome
          paymentMethod
          educationLevel
          jobCategories{
            name
          }
          currentPosition {
            title
            seniority
            company {
              size
              industry
            }
          }
          linkedinFields {
            emailAddress
            educationLevel
            linkedinUrl
            currentPosition {
              title
              description
              seniority
              company {
                name
                size
                industry
              }
              startDate {
                year
                month
              }
              endDate {
                year
                month
              }
            }
          }
        }
      }
      screenerSession {
        id
        screenerSessionAnswers {
          id
          questionId
          questionOptionId
        }
      }
      segment {
        name
      }
    }
  }
`;

const SAVE_MEETING_ID = gql`
  mutation SaveMeetingWindowId($projectId: ID!, $meetingWindowId: String!, $meetingAccountToken: String!) {
    saveMeetingId(projectId: $projectId, meetingId: $meetingWindowId, meetingAccountToken: $meetingAccountToken) {
      project {
        id
        name
      }
    }
  }
`;

export const saveMeetingId = async (projectId, meetingWindowId, meetingAccountToken) => {
  const { data } = await client.getClient().mutate({
    mutation: SAVE_MEETING_ID,
    variables: { projectId, meetingWindowId, meetingAccountToken },
  });

  return data.analytics;
};

const GET_MEETING_LINK = gql`
  query GetMeetingLink($companyId: ID!) {
    company(id: $companyId) {
      id
      name
      callLink
    }
  }
`;

export const getMeetingLink = async (companyId) => {
  const { data } = await client.getClient().query({
    query: GET_MEETING_LINK,
    variables: { companyId },
  });

  return data;
};

export const SAVE_AVAILABILITY = gql`
  mutation CreateAvailabilityMutation($projectId: ID!, $attributes: [AvailabilityAttributes!]!) {
    createAvailability(projectId: $projectId, attributes: $attributes) {
      project {
        id
        availabilities {
          id
          startAt
          endAt
        }
      }
    }
  }
`;

export const SUBMIT_AVAILABILITY = gql`
  mutation UpdateProject($id: ID!, $attributes: ProjectAttributes!) {
    updateProject(id: $id, attributes: $attributes) {
      project {
        id
        submittedAvailabilities
      }
    }
  }
`;

export const UPDATE_BUFFER_TIME = gql`
  mutation UpdateProject($id: ID!, $attributes: ProjectAttributes!) {
    updateProject(id: $id, attributes: $attributes) {
      project {
        id
        bufferTime
        timeZone
        maxBookings
        bookingNotice
        lockVersion
      }
    }
  }
`;

export const UPDATE_BOOKING_STATUS = gql`
  mutation UpdateBookingStatusMutation($id: ID!, $bookingStatus: TestSessionBookingStatusEnum!) {
    updateBookingStatus(id: $id, bookingStatus: $bookingStatus) {
      testSession {
        id
        bookingStatus
      }
    }
  }
`;

export const GET_COMPANY_BY_ID = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      plan
      stripeCustomerId
    }
  }
`;

export const GET_COMPANY_MEMBER_BY_USER_ID = gql`
  query CompanyMemberByUserId($userId: ID!) {
    companyMembers(userId: $userId) {
      id
      company{
        id
        plan
        stripeCustomerId
      }
      user{
        email
      }
      companyServiceIntegrations {
        id
        serviceIntegration {
          id
          name
          category
        }
      }
    }
  }
`;
